<template>
  <div class="flex flex-col items-start gap-2">
    <span v-if="inherited" class="text-body text-beige-50">
      Inherited from <RouterLink :to="inherited.link">{{ inherited.name }}</RouterLink>
    </span>
    <RfColorTag
      v-else-if="category"
      :backgroundColor="getCategoryColor(category)"
      :title="getCategoryLabel(category)"
      pill
      disabled
      class="p-0! *:py-1!"
    />
    <span v-else class="text-body text-beige-50">Not set</span>
  </div>
</template>

<script setup>
import RfColorTag from "@/components/tags/RfColorTag.vue";
import { getCategoryColor, getCategoryLabel } from "@/utils/constants/EngagementCategoryConstants";

defineProps({
  category: { type: String, default: null },
  inherited: { type: Object, default: null },
});
</script>